import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "pt-20 h-full"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "row h-full px-6 mt-6",
  style: {"height":"calc( 100vh - 12.5rem )"}
}
const _hoisted_6 = {
  class: "column side",
  style: {"display":"flex","flex-direction":"column","overflow":"auto"}
}
const _hoisted_7 = {
  class: "bg-slate-200 h-10 px-4",
  style: {"align-content":"center","display":"flex","text-align":"center","justify-content":"center","margin-left":"auto","align-items":"center"}
}
const _hoisted_8 = { style: {"text-align":"center","justify-content":"center","display":"flex","align-items":"center"} }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = {
  class: "column middle play block h-full",
  style: {}
}
const _hoisted_20 = {
  style: {"height":"calc(60vh)"},
  class: "pb-4"
}
const _hoisted_21 = { class: "justify-center h-full w-full my-4 text-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "There are no recorded videos for this play", -1)
const _hoisted_23 = [
  _hoisted_22
]

import Card from 'primevue/card';
import videojs from "video.js";
import "video.js/dist/video-js.css";
import Button from 'primevue/button';
import Panel from 'primevue/panel';
import ProgressSpinner from 'primevue/progressspinner';

import { useRoute } from 'vue-router'
import { CubeQuery, SearchFilter, Data } from '@/models/queryBuilder'
import { ref, Ref, onMounted, onBeforeMount } from 'vue'
import axios from 'axios'
import { authStore } from "../store/index";
import { useApiStore } from "../store/api/api";
import { useVideoApiStore } from "../store/api/videoApi"
import DataTabs from '@/components/DataTabs.vue';
const BASE_URL = 'https://sandbox.hyperlayer.virtualeye.com/video/'

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailedPlayView',
  setup(__props) {

const route = useRoute()
const auth = authStore();
const api = useApiStore();
const videoApi = useVideoApiStore();
const videoHeaders: Ref<string[]> = ref([])
let isLoading = ref(true)
let noVideo = ref(false)
let responseStore = null
let playerItems = ref([])
let headers = ref(['north', 'south east', 'south west'])

onMounted(async () => {
    await query(state.value.queryTable);
    await videoApi.authorize();
    await determineAvailableVideos()
})

const state = ref({
    queryTable: <CubeQuery>{
        dimensions: [
            "plays.play_key",
            "matches.match_type",
            "matches.day_nighter",
            "matches.country",
            "venues.city",
            "venues.stadium",
            "matches.start_date",
            "plays.timestamp",
            "home_team.name",
            "away_team.name",
            "bowling_team.name",
            "batting_team.name",
            "striker.display_name",
            "non_striker.display_name",
            "bowler.display_name",
            "plays.innings",
            "plays.over",
            "plays.delivery",
            "plays.ball",
            "plays.wicket_fell",
            "plays.bowl_end",
            "non_striker.home_away",
            "striker.home_away",
            "bowler.home_away",
            "bowler.team",
            "striker.team",
            "non_striker.team",
            "striker.bat_hand",
            "non_striker.bat_hand",
            "bowler.bat_hand",
            "bowler.bowl_style",
            "plays.break_after_ball"
        ],
        measures: ["plays.total_runs", "plays.wickets", "plays.wides", "plays.byes", "plays.leg_byes", "plays.runs", "plays.bowling_runs", "plays.speed_from_hand_total", "plays.no_balls"],
        order: {},
        filters: [{ "member": "plays.play_key", "operator": "equals", "values": [`${route.query.q}`] }],
        limit: 24,
        offset: 0
    },
    resultPlay: {
    },
    isLoading: true
})

async function query(query) {
    await api.queryGeneric(query).then(response => (state.value.resultPlay = JSON.parse(response.data).data[0]));
    // await api.get(`${process.env.VUE_APP_CUBE_BASE_URL}` + query, { headers: { "Authorization": `${auth.user.id_token}` } }).then(response => (state.value.resultPlay = response.data.data[0]))
    playerItemSetup();
    return
}

async function determineAvailableVideos() {
    let response = false

    isLoading.value = true
    for await (const key of headers.value) {
        responseStore = null
        await videoApi.fetchVideo(BASE_URL + route.query.q + `/${key.replace(/\s/g, "")}.m3u8`).then((value) => {
            if (value.data != undefined && !value.data.includes('DOCTYPE html')) {
                responseStore = value.data;
                videoHeaders.value.push(key);
            }
        });

        if (responseStore) {
            response = true
            var player = videojs(key.replace(/\s/g, ""), {
                html5: {
                    vhs: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions : false
                    },
                }
            });
            player.responsive(true);
            player.ready(function () {
                player.src({
                    src: BASE_URL + route.query.q + `/${key.replace(/\s/g, "")}.m3u8`,
                    type: "application/x-mpegURL",
                    withCredentials: true
                });
            });
        }
    }
    if (response === false) {
        noVideo.value = true
    }
    isLoading.value = false

}

function playerItemSetup() {
    playerItems.value.push({
        name: state.value.resultPlay["striker.display_name"],
        place: state.value.resultPlay["striker.team"],
        role: "Striker",
        home: state.value.resultPlay["striker.home_away"],
        hand: state.value.resultPlay["striker.bat_hand"]
    });
    playerItems.value.push({
        name: state.value.resultPlay["non_striker.display_name"],
        place: state.value.resultPlay["non_striker.team"],
        role: "Non Striker",
        home: state.value.resultPlay["non_striker.home_away"],
        hand: state.value.resultPlay["non_striker.bat_hand"]
    });
    playerItems.value.push({
        name: state.value.resultPlay["bowler.display_name"],
        place: state.value.resultPlay["bowler.team"],
        role: "Bowler",
        home: state.value.resultPlay["bowler.home_away"],
        hand: state.value.resultPlay["bowler.bat_hand"],
        style: state.value.resultPlay["bowler.bowl_style"]
    });
    state.value.isLoading = false
}


return (_ctx: any,_cache: any) => {
  const _component_video_js = _resolveComponent("video-js")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (!state.value.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (state.value.resultPlay['venues.city'])
              ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(state.value.resultPlay["home_team.name"]) + " vs " + _toDisplayString(state.value.resultPlay["away_team.name"]) + " @ " + _toDisplayString(state.value.resultPlay["venues.stadium"]) + " - " + _toDisplayString(state.value.resultPlay["matches.start_date"].split('T')[0]) + " - Inn: " + _toDisplayString(state.value.resultPlay["plays.innings"]) + " Ovr: " + _toDisplayString(state.value.resultPlay["plays.over"]) + " Ball: " + _toDisplayString(state.value.resultPlay["plays.ball"]) + " Delivery: " + _toDisplayString(state.value.resultPlay["plays.delivery"]), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Panel), {
                class: "border-solid border-2 rounded-md border-[#e5e7eb]",
                header: "Players in play",
                toggleable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(playerItems), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mb-2",
                      key: item.name
                    }, [
                      _createVNode(_unref(Card), { style: {"width":"100%","overflow":"hidden"} }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(item.role), 1),
                            _createVNode(_unref(Button), {
                              style: {"margin-left":"auto","text-align":"center","justify-content":"center","border-width":"0.1rem","border-color":"black","height":"fit-content"},
                              class: "px-1",
                              label: "More",
                              severity: "secondary"
                            })
                          ])
                        ]),
                        title: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(item.name), 1)
                        ]),
                        subtitle: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.place), 1)
                        ]),
                        content: _withCtx(() => [
                          (item.home)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createTextVNode(" Home/Away: " + _toDisplayString(item.home) + " ", 1),
                                _hoisted_10
                              ]))
                            : _createCommentVNode("", true),
                          (item.hand)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createTextVNode(" Handedness: " + _toDisplayString(item.hand) + " ", 1),
                                _hoisted_12
                              ]))
                            : _createCommentVNode("", true),
                          (item.style)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createTextVNode(" Bowl Style: " + _toDisplayString(item.style) + " ", 1),
                                _hoisted_14
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_unref(Panel), {
                class: "border-solid border-2 rounded-md border-[#e5e7eb]",
                header: "Play Details",
                style: {"margin-top":"1rem"},
                toggleable: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Wicket Fell: " + _toDisplayString(state.value.resultPlay["plays.wicket_fell"] != 0 ? 'Yes' : 'No') + " ", 1),
                  _hoisted_15,
                  _createTextVNode(" Bowl End: " + _toDisplayString(state.value.resultPlay["plays.bowl_end"] == 0 ? 'North' : 'South') + " ", 1),
                  _hoisted_16,
                  _createTextVNode(" Ball Speed From Hand: " + _toDisplayString(state.value.resultPlay["plays.speed_from_hand_total"]) + " ", 1),
                  _hoisted_17,
                  _createTextVNode(" Time Bowled: " + _toDisplayString(state.value.resultPlay["plays.timestamp"]) + " ", 1),
                  _hoisted_18,
                  _createTextVNode(" Break After Ball: " + _toDisplayString(state.value.resultPlay["plays.break_after_ball"] != 0 ?
            state.value.resultPlay["plays.break_after_ball"]
            : 'No'), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createVNode(DataTabs, {
                style: {"text-transform":"capitalize"},
                headers: videoHeaders.value,
                "team-manager-active": 0,
                class: "mb-3"
              }, {
                default: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_video_js, {
                      id: slotProps.header.replace(/\s/g, '') ,
                      class: "video-js h-full w-full my-4 mt-2",
                      width: "640",
                      height: "268",
                      controls: "",
                      preload: "auto"
                    }, null, 8, ["id"])
                  ])
                ]),
                _: 1
              }, 8, ["headers"]), [
                [_vShow, !_unref(noVideo) && !_unref(isLoading)]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_21, _hoisted_23, 512), [
                [_vShow, _unref(noVideo)]
              ]),
              (_unref(isLoading))
                ? (_openBlock(), _createBlock(_unref(ProgressSpinner), {
                    key: 0,
                    class: "justify-center",
                    "attrs-color-black": "",
                    style: {"width":"90px","height":"90px","margin-left":"45%","margin-top":"25%"},
                    strokeWidth: "5",
                    animationDuration: "1s",
                    "aria-label": "Loading"
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_unref(ProgressSpinner), {
          key: 1,
          class: "absolute m-auto left-0 right-0 top-0 bottom-0",
          "attrs-color-black": "",
          style: {"width":"90px","height":"90px"},
          strokeWidth: "5",
          animationDuration: "1s",
          "aria-label": "Loading"
        }))
  ]))
}
}

})